export const tlsAccTip = '将TLS证书验证卸载到硬件中执行，可提高HTTPS请求的性能。';
